import { Box } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { ToastProps } from '../../interfaces/components';

function Toast({ activeLocale, text, active, position = 'absolute', setActive }: ToastProps) {
  useEffect(() => {
    if (active) {
      setTimeout(() => {
        setActive(false);
      }, 3000);
    }
  }, [active]);

  return (
    <Box
      zIndex="999999"
      position={position}
      width="200px"
      textAlign="center"
      top={['20px']}
      left="0"
      right="0"
      margin="auto"
      visibility={active ? 'unset' : 'hidden'}
      opacity={active ? '1' : '0'}
      transition="all 0.5s"
      bg="#FDC506"
      p="10px"
      fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
    >
      {text}
    </Box>
  );
}

export default Toast;
